import { date, showAlert } from '@/lib/helpers';
import { headers, search, categoryOptions, statusOptions } from './attributes';

export default {
  data() {
    return {
      options: {},
      headers,
      search,
      dialog: false,
      isEdit: false,
      editedIndex: -1,
      editedItem: {
        id: null,
        code: '',
        category: null,
        description: '',
        status: 1,
      },
      defaultItem: {
        id: null,
        code: '',
        category: null,
        description: '',
        status: 1,
      },
      formLoading: false,
      formErrors: {},
    };
  },
  computed: {
    filterData() {
      return [
        { label: 'Kode Penutupan', field: 'code', type: 'text' },
        { label: 'Kategori', field: 'category', type: 'select', items: categoryOptions },
        { label: 'Deskripsi', field: 'description', type: 'text' },
        { label: 'Status', field: 'status', type: 'select', items: statusOptions },
      ];
    },
    allData() {
      return this.$store.state.closedMerchantCategory.allData;
    },
    totalData() {
      return this.$store.state.closedMerchantCategory.totalData;
    },
    totalPage() {
      return this.$store.state.closedMerchantCategory.totalPage;
    },
    loading() {
      return this.$store.state.closedMerchantCategory.loading;
    },
    dialogTitle() {
      return this.isEdit ? 'Edit Kategori' : 'Add Kategori';
    },
    formFields() {
      return [
        {
          key: 'code',
          label: 'Kode Penutupan',
          type: 'text',
          maxLength: 3,
          uppercase: true,
          rules: [
            v => !!v || 'Kode Penutupan is required',
            v => !v || /^[A-Z0-9]+$/.test(v) || 'Kode hanya boleh berisi huruf dan angka.',
            v => !v || (v.length >= 2 && v.length <= 3) || 'Code Must be 2-3 characters',
          ],
        },
        {
          key: 'category',
          label: 'Kategori',
          type: 'select',
          items: categoryOptions,
          rules: [
            v => (v !== null && v !== undefined && v !== '') || 'Kategori is required',
          ],
        },
        {
          key: 'description',
          label: 'Deskripsi',
          type: 'textarea',
          rows: 3,
          maxLength: 100,
          rules: [
            v => !!v || 'Deskripsi is required',
            v => !v || v.length <= 100 || 'Deskripsi maksimal 100 karakter.',
          ],
        },
        {
          key: 'status',
          label: 'Status',
          type: 'select',
          items: statusOptions,
          rules: [
            v => (v !== null && v !== undefined && v !== '') || 'Status is required',
          ],
        },
      ];
    },
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },
  methods: {
    getData() {
      const { page = 1, itemsPerPage = 10 } = this.options;

      this.$store
        .dispatch('closedMerchantCategory/getData', {
          date,
          page,
          itemsPerPage,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            this.options.page = this.totalPage === 0 ? 1 : this.totalPage;
          }
        });
    },
    openAddDialog() {
      this.isEdit = false;
      this.editedIndex = -1;
      this.editedItem = { ...this.defaultItem };
      this.formErrors = {};
      this.dialog = true;
    },
    async openEditDialog(item) {
      this.isEdit = true;
      this.editedIndex = this.allData.indexOf(item);
      this.formErrors = {};

      // Ambil detail terbaru via endpoint view; fallback ke data row bila gagal
      let detail = item;
      const response = await this.$store.dispatch('closedMerchantCategory/viewData', {
        date,
        id: item.id,
      });
      if (response?.code === 200 && response.data) {
        detail = response.data;
      }

      this.editedItem = {
        id: detail.id,
        code: detail.code,
        category: detail.category,
        description: detail.description,
        status: detail.status,
      };
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.formErrors = {};
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
        this.isEdit = false;
      });
    },
    async saveItem(formData) {
      this.formLoading = true;
      this.formErrors = {};

      const payload = {
        date,
        code: formData.code,
        category: formData.category,
        description: formData.description,
        status: formData.status,
      };

      try {
        let response;
        if (this.isEdit) {
          response = await this.$store.dispatch('closedMerchantCategory/updateData', {
            ...payload,
            id: this.editedItem.id,
          });
        } else {
          response = await this.$store.dispatch('closedMerchantCategory/createData', payload);
        }

        if (response?.code === 200) {
          showAlert(
            this.$store,
            this.isEdit ? 'Data berhasil diupdate!' : 'Data berhasil ditambahkan!',
            'mdi-check-circle',
            'green'
          );
          this.closeDialog();
          this.getData();
        } else {
          this.handleFieldErrors(response?.data);
          const errorMessage = this.extractErrorMessage(response, 'Terjadi kesalahan!');
          // BE mengirim error duplikat code hanya lewat message (data null),
          // tampilkan juga di bawah field Kode Penutupan
          if (/code already exist/i.test(errorMessage)) {
            this.formErrors = { ...this.formErrors, code: [errorMessage] };
          }
          showAlert(this.$store, errorMessage, 'mdi-alert', 'red');
        }
      } catch (error) {
        showAlert(this.$store, 'Terjadi kesalahan!', 'mdi-alert', 'red');
      } finally {
        this.formLoading = false;
      }
    },
    handleFieldErrors(responseData) {
      if (!responseData) return;

      if (typeof responseData === 'object' && responseData !== null && !Array.isArray(responseData)) {
        this.formErrors = { ...responseData };
      }
    },
    extractErrorMessage(responseData, defaultMessage) {
      if (!responseData) return defaultMessage;

      const { data, message_en, message_id } = responseData;

      if (typeof data === 'string' && data.trim()) {
        return data;
      }

      if (typeof data === 'object' && data !== null && !Array.isArray(data)) {
        const firstField = Object.keys(data)[0];
        if (firstField && Array.isArray(data[firstField]) && data[firstField].length > 0) {
          return data[firstField][0];
        }
      }

      return message_en || message_id || defaultMessage;
    },
    clearSearch() {
      this.search.code = '';
      this.search.category = '';
      this.search.description = '';
      this.search.status = '';
    },
    updateSearch() {
      this.getData();
    },
    showType() {
      this.getData();
    },
  },
  beforeRouteLeave(to, from, next) {
    this.clearSearch();
    next();
  },
};
